export function getSpektrixCheckoutReturn(webApiBaseUrl: string, search: string): string | null {
  const params = new URLSearchParams(search)
  const token = params.get("SpektrixPasswordlessToken")
  const redirect = params.get("SpektrixRedirectUrl")
  if (!token || !redirect) return null

  try {
    const secureCheckout = new URL("../website/secure/", webApiBaseUrl)
    const checkoutReturn = new URL(redirect)
    if (
      secureCheckout.protocol !== "https:" ||
      checkoutReturn.origin !== secureCheckout.origin ||
      checkoutReturn.username ||
      checkoutReturn.password ||
      !checkoutReturn.pathname.startsWith(secureCheckout.pathname) ||
      /%2f|%5c/i.test(checkoutReturn.pathname)
    ) {
      return null
    }

    checkoutReturn.searchParams.set("SpektrixPasswordlessToken", token)
    checkoutReturn.searchParams.delete("resize")
    checkoutReturn.searchParams.set("resize", "true")
    return checkoutReturn.href
  } catch {
    return null
  }
}
